<script>
export default {
  name: "reservedPropertyCard",
  props: {
    properties: {}
  },
  methods: {
    setStatus(row) {
      var status = "N/A";
      switch (row.orderType) {
        case "Select Now":
          status = "Reserved";
          break;
        case "Make Offer":
          status = "Offered";
        default:
          break;
      }
      return status;
    },
    numberWithCommas(row) {
      var price = 0;
      switch (row.orderType) {
        case "Select Now":
          price = row.propertyPrice;
          break;
        case "Make Offer":
          price = row.offeredPrice;
        default:
          break;
      }
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<template>
  <div>
    <el-row
      v-for="(item, index) in this.properties"
      :key="index"
      style="padding: 10px 0"
    >
      <el-col :span="24">
        <el-card style="width: 100%;">
          <el-row style="padding: 5px 0">
            <el-col :span="12">
              <span class="label-title">Dwelling</span>
            </el-col>
            <el-col :span="12">
              <span class="label-desc">{{ item.dwellingNumber }}</span>
            </el-col>
          </el-row>
          <el-row style="padding: 5px 0">
            <el-col :span="12">
              <span class="label-title">Address</span>
            </el-col>
            <el-col :span="12">
              <span class="label-desc">{{ item.address }}</span>
            </el-col>
          </el-row>
          <el-row style="padding: 5px 0">
            <el-col :span="12">
              <span class="label-title">Price</span>
            </el-col>
            <el-col :span="12">
              <span class="label-desc">$ {{ numberWithCommas(item) }}</span>
            </el-col>
          </el-row>
          <el-row style="padding: 5px 0">
            <el-col :span="12">
              <span class="label-title">Status</span>
            </el-col>
            <el-col :span="12">
              <span class="label-desc">{{ setStatus(item) }}</span>
            </el-col>
          </el-row>
          <el-row style="padding: 5px 0">
            <el-col :span="12">
              <span class="label-title">Date</span>
            </el-col>
            <el-col :span="12">
              <span class="label-desc">{{ item.reservedDate }}</span>
            </el-col>
          </el-row>
          <el-row style="padding: 5px 0">
            <el-col :span="12">
              <span class="label-title">Agent</span>
            </el-col>
            <el-col :span="12">
              <div class="label-desc" v-for="agent in item.agentPojoList">
                <span>{{ agent.firstName }} {{ agent.lastName }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row style="padding: 5px 0">
            <el-col :span="12">
              <span class="label-title">Legal Rep.</span>
            </el-col>
            <el-col :span="12">
              <span class="label-desc">{{ item.legalRepName }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.label-title {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 115%;
}
.label-desc {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 115%;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/reservedPropertyCard.vue